import React from "react";
import { Tooltip } from "@mui/material";
import { statusLabel } from "../common/StatusChip";

// Backend moderation state -> the StatusChip key that labels it.
export const MODERATION_CHIP = {
  final_approved: "final_approved",
  overridden: "overridden",
  approved: "moderation_approved",
  final_rejected: "final_rejected",
  rejected: "moderation_rejected",
  pending: "moderation_pending",
  in_qc: "qc_pending",
  not_delivered: "delivery_pending",
};

// Solid = final decision, tinted with a ring = moderator's decision awaiting final, grey = not with moderation yet.
const DOT_STYLE = {
  final_approved: "bg-emerald-600 text-white",
  overridden: "bg-emerald-600 text-white ring-2 ring-emerald-200",
  approved: "bg-emerald-50 text-emerald-700 ring-1 ring-inset ring-emerald-500",
  final_rejected: "bg-rose-600 text-white",
  rejected: "bg-rose-50 text-rose-700 ring-1 ring-inset ring-rose-500",
  pending: "bg-amber-400 text-white",
  in_qc: "bg-gray-300 text-white",
  not_delivered: "bg-gray-300 text-white",
};

/** One numbered dot per hook, coloured by its moderation state; click opens the detail modal. */
const ModerationHookDots = ({ hooks, onClick }) => {
  if (!hooks?.length) return <span className="text-gray-400">—</span>;
  return (
    <div className="flex max-w-[102px] flex-wrap gap-[3px]">
      {hooks.map((h) => (
        <Tooltip key={h.hook_number} arrow title={`Hook ${h.hook_number} · ${statusLabel(MODERATION_CHIP[h.state] ?? h.state)}${h.overridden_by ? ` by ${h.overridden_by}` : ""}`}>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onClick();
            }}
            className={`flex h-[18px] w-[18px] items-center justify-center rounded-full text-[10px] font-semibold leading-none transition-transform hover:scale-125 ${DOT_STYLE[h.state] ?? DOT_STYLE.not_delivered}`}
          >
            {h.hook_number}
          </button>
        </Tooltip>
      ))}
    </div>
  );
};

export default ModerationHookDots;
